import { Flex, Spacing } from '@billy/design-system'
import { ReactElement } from 'react'

import { BankMatchesDateSelector } from './elements/BankMatchesDateSelector'
import { BankMatchesSearch } from './elements/BankMatchesSearch'
import { BankMatchesSorting } from './elements/BankMatchesSorting'
import { BankMatchesTypesSelector } from './elements/BankMatchesTypesSelector'

export const BankMatchesToolbar = (): ReactElement => {
  return (
    <Flex justifyContent="space-between" alignItems="center">
      <Flex gap={Spacing.S16} alignItems="center">
        <BankMatchesDateSelector />
        <BankMatchesSorting />
        <BankMatchesTypesSelector />
      </Flex>
      <BankMatchesSearch />
    </Flex>
  )
}
